import CrmAccount from "../model"

export default class CrmAccountAccessControl {

    private account : CrmAccount

    constructor(account:CrmAccount) {
        this.account = account
    }

    get canEdit(): boolean {
        return gd.ac.check.company.canEditCustomers()
    }

    get canChangeCustomFields(): boolean {
        return this.canEdit
    }
}
